(function (angular, app) {
    'use strict';

    angular
        .module(app.modules.common.name)
        .factory('hub', hub);

    hub.$inject = ['$q', '$timeout'];
    function hub($q, $timeout) {
        return function createHub(url, name) {
            // Vars
            var result = {}, connection, hub, config, reconnecting;

            // Init
            connection = $.hubConnection(url, { useDefaultPath: false });
            connection.disconnected(onDisconnected);
            connection.reconnecting(onReconnecting);
            connection.reconnected(onReconnected);
            hub = connection.createHubProxy(name);
            hub.on('_' + new Date().getTime(), angular.noop);

            // Interface
            result.connect = connect;
            result.disconnect = disconnect;
            result.invoke = invoke;
            result.on = on;
            result.off = off;   
            return result;

            // Implementation
            function connect(options) {
                config = angular.extend({}, options);
                connection.logging = !!config.logging;
                return $q.when(connection.start(config));
            }
            function disconnect() {
                connection.stop()
            }
            function invoke(methodName, args) {
                var args = Array.prototype.slice.apply(arguments);
                return ensureConnected().then(function () {
                    return $q.when(hub.invoke.apply(hub, args));
                });
            }
            function on(eventName, callback) {
                hub.on(eventName, callback);
            }
            function off(eventName, callback) {
                hub.off(eventName, callback);
            }

            // Continuous Reconnect (if disconnected)
            function onDisconnected() {
                if (reconnecting)
                    $timeout(connect, 5000, false, config);
            };
            function onReconnecting() {
                reconnecting = true;
            }
            function onReconnected() {
                reconnecting = false;
            }

            // Helpers
            function ensureConnected() {
                var stateEnum = $.signalR.connectionState, state = connection.state;
                if (state == stateEnum.disconnected && connection._deferral)
                    state = stateEnum.connecting;

                return state == stateEnum.disconnected ? connect() : state == stateEnum.connecting ? $q.when(connection._deferral.promise()) : $q.resolve();
            }
        }
    }
})(angular, app);